import { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import { useClickOutside } from '@/ui/SimpleModal/hooks/useClickOutside';

interface EmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
}

export const EmailModal: React.FC<EmailModalProps> = ({ isOpen, className, onClose }) => {
  const [emailInput, setEmailInput] = useState('');

  const contentRef = useRef<HTMLDivElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);

  // Auto focus the email input when modal opens
  useEffect(() => {
    if (isOpen && emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, [isOpen]);

  // If the modal scrolls out of view at all, close it
  useEffect(() => {
    if (!contentRef.current) return;

    const observer = new IntersectionObserver(([entry]) => entry.intersectionRatio < 1 && onClose(), {
      threshold: [1],
    });

    observer.observe(contentRef.current);

    return () => observer.disconnect();
  }, [onClose]);

  useClickOutside({
    isOpen,
    onClose,
    contentRef,
    shouldCloseOnOutsideClick: true,
    shouldDisableScroll: true,
  });

  return (
    <div
      ref={contentRef}
      className={classNames(
        'absolute p-4 rounded-lg bg-[--site-theme-background-color] border border-[--site-theme-border-color] z-[999]',
        !isOpen && 'hidden',
        className,
      )}
    >
      <input
        ref={emailInputRef}
        type="email"
        name="email"
        value={emailInput}
        autoComplete="email"
        onChange={(e) => setEmailInput(e.target.value)}
        placeholder="Email"
        className="border border-[--site-theme-border-color] focus:border-[--site-theme-primary-color] rounded w-full mb-2"
      />
      <button
        type="submit"
        onClick={onClose}
        className={classNames(
          'px-4 py-2 rounded-[--site-theme-border-radius] bg-[--site-theme-primary-color] text-[--site-theme-background-color] font-medium text-center block w-full',
        )}
        style={{ fontFamily: 'var(--site-theme-button-font)' }}
      >
        Subscribe
      </button>
    </div>
  );
};
